// Sidebar brand block: KantoBiz logo + ADMIN label + divider.
import { Box, Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
import logo from "assets/img/logo.png";

/**
 * Renders the sidebar brand header (logo, ADMIN title and a separator line).
 * @returns {React.ReactElement}
 */
export default function SidebarBrand() {
  const dividerColor = useColorModeValue("secondaryGray.200", "whiteAlpha.200");
  const textColor = useColorModeValue("navy.700", "white");
  return (
    <Flex align="center" direction="column" px="20px">
      <Flex align="center" gap="10px" my="28px">
        <Image src={logo} alt="KantoBiz" h="36px" w="auto" />
        <Text fontSize="lg" fontWeight="bold" color={textColor} letterSpacing="2px">
          ADMIN
        </Text>
      </Flex>
      <Box w="100%" h="1px" bg={dividerColor} mb="12px" />
    </Flex>
  );
}
